import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { UserGroupService } from '../../service/data/user-group.service';
import { UserGroup } from '../../model/user-group';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { LocationAccessGroupService } from '../../service/data/location-access-group.service';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { LocationAccessGroup } from '../../model/location-access-group';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';

@Component({
    selector: 'app-location-accesss-group-manager',
    templateUrl: './location-access-group-manager.component.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LocationAccessGroupManagerComponent extends PagedObjectManagerComponent<LocationAccessGroup> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: LocationAccessGroupService,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getLocationAccessGroupColumnDefinition();
    this.title = 'LOCATION_ACCESS.GROUP_LIST_HEADER';

    this.preferencesKey = 'common.location-access-group-manager.list';
  }

  accessControlEnabled: boolean = true;

  ngOnInit() {
    this.AddSubscription(this._dataService.getAccessControlStatus().subscribe(val => (this.accessControlEnabled = val)));
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'LOCATION_ACCESS.GROUP_NAME',
            'nameContains',
            definition.nameContains,
            null,
            definition.selectedFields.includes('nameContains')
          ),
        ];
      })
    );
    this.addEditDeleteCommands();
  }
}
